export default {
    palette: {
        background: {
            default: "#e4f0e2"
        }
    }
};